import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Root as Root2, Item as Item2, Indicator } from '../../../../../_externals/.pnpm/@radix-ui_react-radio-group@1.2.0_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-radio-group/dist/index.js';
import { generateBorder } from '../../../../helpers/tokens.js';

var radioCheck = {
    content: '""',
    position: "absolute",
    transform: "translateY(-50%) translateX(-50%)",
    width: "10px",
    height: "10px",
    top: "50%",
    left: "50%",
    borderRadius: tokens.spacing[6],
};
var RadioInputContainer = styled(Root2)({
    display: "flex",
    flexDirection: "column",
});
var RadioInputItem = styled.div({
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacing[3],
    margin: "".concat(tokens.spacing[2], " 0"),
});
var RadioInput = styled(Item2)(function (_a) {
    var disabled = _a.disabled, checked = _a.checked;
    return ({
        display: "flex",
        minWidth: "20px",
        height: "20px",
        background: disabled ? tokens.color.airJordan[200] : "none",
        padding: 0,
        border: generateBorder("xs", "solid", disabled ? "airJordan.300" : "airJordan.p"),
        borderRadius: "100%",
        position: "relative",
        "&:after": __assign(__assign({}, radioCheck), { opacity: 0, transition: "0.2s all", backgroundColor: tokens.color.airJordan[300] }),
        "&:focus": {
            outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.foamRunner[500]),
            outlineOffset: tokens.borderWidth.s,
        },
        "&:hover": {
            "&:after": {
                opacity: checked || disabled ? 0 : 1,
            },
        },
    });
});
var RadioInputIndicator = styled(Indicator)(function (_a) {
    var checked = _a.checked;
    return ({
        display: "flex",
        width: "100%",
        height: "100%",
        position: "relative",
        "&:after": __assign(__assign({}, radioCheck), { backgroundColor: checked ? tokens.color.airJordan.p : tokens.color.yeezy[0] }),
    });
});

export { RadioInput, RadioInputContainer, RadioInputIndicator, RadioInputItem };
//# sourceMappingURL=RadioInput.styles.js.map
